export async function sharePost(postId: string, authorUsername: string, contentPreview: string): Promise<boolean> {
  const url = `${window.location.origin}/og/posts/${postId}`
  const plainText = contentPreview.replace(/<[^>]+>/g, '').slice(0, 100)
  const text = `@${authorUsername} on OlimHub: ${plainText}`

  if (navigator.share) {
    await navigator.share({ url, text })
    return true
  }

  await navigator.clipboard.writeText(url)
  return false
}
